/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Coveralt1Inputs */

const id_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karya Seni Sampul LEGO Star Wars: The Skywalker Saga`)
};

const ms_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karya Seni Kulit LEGO Star Wars: The Skywalker Saga`)
};

const da_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars: The Skywalker Saga Cover Art`)
};

const de_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars: The Skywalker Saga Cover Art`)
};

const en_us2_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars: The Skywalker Saga Cover Art`)
};

const es_es2_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arte de portada de LEGO Star Wars: The Skywalker Saga`)
};

const es_mx2_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arte de portada de LEGO Star Wars: The Skywalker Saga`)
};

const fil_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover Art ng LEGO Star Wars: The Skywalker Saga`)
};

const fr_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustration de couverture LEGO Star Wars : The Skywalker Saga`)
};

const it_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copertina LEGO Star Wars: The Skywalker Saga`)
};

const hu_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars: The Skywalker Saga borítókép`)
};

const nl_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars: The Skywalker Saga Omslagkunst`)
};

const no_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars: The Skywalker Saga-cover`)
};

const pl_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafika okładkowa LEGO Star Wars: The Skywalker Saga`)
};

const pt_br2_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars: Arte da capa da saga Skywalker`)
};

const pt_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arte de capa LEGO Star Wars: The Skywalker Saga`)
};

const ro_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opera de copertă LEGO Star Wars: The Skywalker Saga`)
};

const fi_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars: The Skywalker Saga -kansikuva`)
};

const sv_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars: The Skywalker Saga-omslag`)
};

const vi_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh bìa LEGO Star Wars: The Skywalker Saga`)
};

const tr_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars: The Skywalker Saga Kapak Görseli`)
};

const cs_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obálka LEGO Star Wars: The Skywalker Saga`)
};

const bg_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Корица на LEGO Star Wars: The Skywalker Saga`)
};

const ru_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обложка LEGO Star Wars: The Skywalker Saga`)
};

const uk_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обкладинка LEGO Star Wars: The Skywalker Saga`)
};

const ar_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غلاف LEGO Star Wars: The Skywalker Saga`)
};

const hi_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars: The Skywalker Saga कवर`)
};

const th_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ภาพปก LEGO Star Wars: The Skywalker Saga`)
};

const ja_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars: The Skywalker Saga カバーアート`)
};

const zh_cn2_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars: The Skywalker Saga 封面图`)
};

const zh_hant1_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars: The Skywalker Saga 封面圖`)
};

const ko_misc_posts_coveralt1 = /** @type {(inputs: Misc_Posts_Coveralt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LEGO Star Wars: The Skywalker Saga 커버 아트`)
};

/**
* | output |
* | --- |
* | "LEGO Star Wars: The Skywalker Saga Cover Art" |
*
* @param {Misc_Posts_Coveralt1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_coveralt1 = /** @type {((inputs?: Misc_Posts_Coveralt1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Coveralt1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_coveralt1(inputs)
	if (locale === "ms") return ms_misc_posts_coveralt1(inputs)
	if (locale === "da") return da_misc_posts_coveralt1(inputs)
	if (locale === "de") return de_misc_posts_coveralt1(inputs)
	if (locale === "en-US") return en_us2_misc_posts_coveralt1(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_coveralt1(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_coveralt1(inputs)
	if (locale === "fil") return fil_misc_posts_coveralt1(inputs)
	if (locale === "fr") return fr_misc_posts_coveralt1(inputs)
	if (locale === "it") return it_misc_posts_coveralt1(inputs)
	if (locale === "hu") return hu_misc_posts_coveralt1(inputs)
	if (locale === "nl") return nl_misc_posts_coveralt1(inputs)
	if (locale === "no") return no_misc_posts_coveralt1(inputs)
	if (locale === "pl") return pl_misc_posts_coveralt1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_coveralt1(inputs)
	if (locale === "pt") return pt_misc_posts_coveralt1(inputs)
	if (locale === "ro") return ro_misc_posts_coveralt1(inputs)
	if (locale === "fi") return fi_misc_posts_coveralt1(inputs)
	if (locale === "sv") return sv_misc_posts_coveralt1(inputs)
	if (locale === "vi") return vi_misc_posts_coveralt1(inputs)
	if (locale === "tr") return tr_misc_posts_coveralt1(inputs)
	if (locale === "cs") return cs_misc_posts_coveralt1(inputs)
	if (locale === "bg") return bg_misc_posts_coveralt1(inputs)
	if (locale === "ru") return ru_misc_posts_coveralt1(inputs)
	if (locale === "uk") return uk_misc_posts_coveralt1(inputs)
	if (locale === "ar") return ar_misc_posts_coveralt1(inputs)
	if (locale === "hi") return hi_misc_posts_coveralt1(inputs)
	if (locale === "th") return th_misc_posts_coveralt1(inputs)
	if (locale === "ja") return ja_misc_posts_coveralt1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_coveralt1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_coveralt1(inputs)
	return ko_misc_posts_coveralt1(inputs)
});
export { misc_posts_coveralt1 as "misc.posts.coverAlt" }